import {useEffect} from "react";
import {useParams, Navigate, useLocation} from "react-router-dom";
import i18n from "./i18n";

const SUPPORTED_LANGS=["pl", "en"];

export default function LanguageWrapper({children}) {
  const {lang}=useParams();
  const location=useLocation();

  useEffect(() => {
    if (lang&&SUPPORTED_LANGS.includes(lang))
    {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  // If lang is not supported → redirect to /pl
  if (!lang||!SUPPORTED_LANGS.includes(lang))
  {
    return <Navigate to="/pl" state={{from: location}} replace />;
  }

  return children;
}
